import { useEffect } from 'react';
import { trackOperationalEvent } from 'src/observability/appInsights';

/**
 * Soft check for a new static build. Failures (auth HTML, offline, etc.)
 * must not surface as App Insights exceptions — they trip exception-spike alerts.
 */
export function useVersionCheck() {
  useEffect(() => {
    let currentVersion = localStorage.getItem('app-version');

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' });
        if (!res.ok) {
          trackOperationalEvent('version_check_failed', {
            path: '/version.json',
            status: res.status,
          });
          return;
        }

        const contentType = res.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
          trackOperationalEvent('version_check_failed', {
            path: '/version.json',
            reason: 'non_json',
          });
          return;
        }

        const data = await res.json();
        const version = data?.version;
        if (!version) {
          return;
        }

        if (currentVersion && currentVersion !== version) {
          console.warn('New build detected — refreshing...');
          window.location.reload(true);
        }

        localStorage.setItem('app-version', version);
        currentVersion = version;
      } catch {
        trackOperationalEvent('version_check_failed', {
          path: '/version.json',
          reason: 'request_error',
        });
      }
    };

    checkVersion();

    window.addEventListener('focus', checkVersion);
    return () => window.removeEventListener('focus', checkVersion);
  }, []);
}
